// extracted by mini-css-extract-plugin
export var separator = "lineSeparator-module--separator--010a7";